import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4d64a85f&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4d64a85f&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d64a85f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d64a85f')) {
      api.createRecord('4d64a85f', component.options)
    } else {
      api.reload('4d64a85f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4d64a85f&scoped=true", function () {
      api.rerender('4d64a85f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modulestore/module/3-2-graphic-list-2/index.vue"
export default component.exports